import type { AttachmentFullViewState } from 'owa-attachment-full-data';
import setShouldShowActionsContainer from 'owa-attachment-full-data/lib/actions/setShouldShowActionsContainer';
import setShouldShowImageOverlay from 'owa-attachment-full-data/lib/actions/setShouldShowImageOverlay';
import shouldAlwaysShowImageOverlay from 'owa-attachment-full-data/lib/utils/shouldAlwaysShowImageOverlay';

const pendingOnBlurTaskMap = {}; // Making this a map so that moving focus from one Attachment to the next does not clear the timer.
let focusedAttachmentId: string | null = null;
export function handleComponentOnFocus(
    attachmentViewState: AttachmentFullViewState,
    isImage: boolean
) {
    if (pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id]) {
        clearTimeout(pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id]);
        pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id] = null;
    }

    focusedAttachmentId = attachmentViewState.attachmentId.Id;
    setShouldShowActionsContainer(attachmentViewState, true);

    if (isImage && !shouldAlwaysShowImageOverlay(attachmentViewState)) {
        setShouldShowImageOverlay(attachmentViewState, true);
    }
}

export function handleComponentOnBlur(
    attachmentViewState: AttachmentFullViewState,
    isImage: boolean
) {
    if (pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id]) {
        clearTimeout(pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id]);
    }
    pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id] = setTimeout(() => {
        setShouldShowActionsContainer(attachmentViewState, false);
        if (isImage && !shouldAlwaysShowImageOverlay(attachmentViewState)) {
            setShouldShowImageOverlay(attachmentViewState, false);
        }

        // We only reset the focused AttachmentId to null if a new attachment was not already focused.
        if (attachmentViewState.attachmentId.Id === focusedAttachmentId) {
            focusedAttachmentId = null;
        }
        pendingOnBlurTaskMap[attachmentViewState.attachmentId.Id] = null;
    }, 40);
}

export function handleOnMouseEnter(attachmentViewState: AttachmentFullViewState, isImage: boolean) {
    setShouldShowActionsContainer(attachmentViewState, true);

    // There are scenarios that we always show image overlay, where we don't need to show the image overlay when mouse is over the image.
    if (isImage && !shouldAlwaysShowImageOverlay(attachmentViewState)) {
        setShouldShowImageOverlay(attachmentViewState, true);
    }
}

export function handleOnMouseLeave(attachmentViewState: AttachmentFullViewState, isImage: boolean) {
    if (attachmentViewState.attachmentId.Id !== focusedAttachmentId) {
        setShouldShowActionsContainer(attachmentViewState, false);

        // There are scenarios that we always show image overlay, where We don't need to hide the image overlay when mouse moves away
        if (isImage && !shouldAlwaysShowImageOverlay(attachmentViewState)) {
            setShouldShowImageOverlay(attachmentViewState, false);
        }
    }
}
